export enum RecurringInvoiceStatus {
  All = 'all', // for listing page purposes
  Completed = 'completed',
  Draft = 'draft',
  Ongoing = 'active',
  Paused = 'inactive',
}
